const ordenDigitalInitialState = {
  ordenDigital: {
    loading: false,
    error: null,
    data: null,
    altaTurno: null,
    grupoMed: null,
    idMedSolicitante: null,
    load: false,
    loadPdf: false,
    pdf: null,
    flgVolver: false,
    fechaOrden: null
  },
};

export default ordenDigitalInitialState;
